import React, { useState } from 'react';
import Avatar from '../Avatar';
import { HuntLeaderboardResponse } from '../../services/types';
import './HuntLeaderboard.css';

interface HuntLeaderboardProps {
    day: HuntLeaderboardResponse | null;
    week: HuntLeaderboardResponse | null;
    loading: boolean;
    currentUserId: number | null;
}

const HuntLeaderboard: React.FC<HuntLeaderboardProps> = ({
    day,
    week,
    loading,
    currentUserId,
}) => {
    const [period, setPeriod] = useState<'day' | 'week'>('day');
    const data = period === 'day' ? day : week;

    return (
        <section className="HuntLeaderboard">
            <div className="HuntLeaderboard-header">
                <h2>Classement</h2>
                <div className="HuntLeaderboard-tabs">
                    <button
                        type="button"
                        className={period === 'day' ? 'is-active' : ''}
                        onClick={() => setPeriod('day')}
                    >
                        Aujourd&apos;hui
                    </button>
                    <button
                        type="button"
                        className={period === 'week' ? 'is-active' : ''}
                        onClick={() => setPeriod('week')}
                    >
                        Cette semaine
                    </button>
                </div>
            </div>

            {loading && <p>Chargement du classement…</p>}
            {!loading && (!data || data.entries.length === 0) && (
                <p className="HuntLeaderboard-empty">Aucun score pour l&apos;instant. Lancez la chasse !</p>
            )}

            {!loading && data && data.entries.length > 0 && (
                <ol className="HuntLeaderboard-list">
                    {data.entries.map((entry) => {
                        const isCurrent = currentUserId !== null && entry.user_id === currentUserId;
                        return (
                            <li
                                key={`${entry.user_id}-${entry.rank}`}
                                className={isCurrent ? 'HuntLeaderboard-entry HuntLeaderboard-entry--current' : 'HuntLeaderboard-entry'}
                            >
                                <span className="HuntLeaderboard-rank">{entry.rank}.</span>
                                <Avatar url={entry.avatar_url} alt={entry.display_name} size="small" />
                                <span className="HuntLeaderboard-name">{entry.display_name}</span>
                                <span className="HuntLeaderboard-score">{entry.score} pts</span>
                            </li>
                        );
                    })}
                </ol>
            )}
        </section>
    );
};

export default HuntLeaderboard;
